import * as actionTypes from '../actions/actionTypes';

const initialState = {
    isLogin: false,
    token: '',
    user: {},
    cards: [],
    managers: {},
    isLoading: false,
    currentRole: null,  // ADD THIS
};

// SUPER_ADMIN is an add-on permission (full financial dashboard), never the active role.
const pickStartingRole = (roles) => {
    const usable = (roles || []).filter((r) => r !== "SUPER_ADMIN");
    return usable.length > 0 ? usable[0] : null;
};

const UserReducer = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case actionTypes.SET_CURRENT_ROLE:  // ADD THIS
            return {
                ...state,
                currentRole: action.payload,
            };    
        case actionTypes.USER_LOGIN:
            return {
                ...state,
                isLogin: true,
                token: action.payload.access_token,
                user: action.payload,
                // Start on the first role, skipping SUPER_ADMIN
                currentRole: pickStartingRole(action.payload.roles)
            };
        case actionTypes.USER_REGISTER:
            return {
                ...state,
                isLogin: true,
                token: action.payload.access_token,
                user: action.payload,
                // Start on the first role, skipping SUPER_ADMIN
                currentRole: pickStartingRole(action.payload.roles)
            };
        case actionTypes.CLEAR_USER:
            return {
                isLogin: false,
                token: '',
                user: {},
                cards: [],
                managers: {},
                isLoading: false,
                currentRole: null,  // RESET ON LOGOUT
            };
        default:
            return state;
    }
}

export default UserReducer;